// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Hallo {{first_name}}, was brauchst du für {{restaurant}}?',
  title_no_name: 'Hallo, was brauchst du für {{restaurant}}?',
  text: 'Ich beantworte Fragen zu {{restaurant}} und ändere Dinge für dich. Nichts ändert sich, bevor du es freigibst.',
  suggestions: 'Vorschläge',
  prompts: {
    reports: {
      top_dishes: 'Was waren letzten Monat die 10 meistbestellten Gerichte?',
      sales_vs_last_month: 'Wie war der Umsatz im Vergleich zum Vormonat?',
    },
    menu: {
      raise_dish_price: 'Erhöh den Preis von {{dish}} um {{amount}}',
      dish_sold_out: '{{dish}} als ausverkauft markieren',
      dishes_without_photo: 'Welche Gerichte haben kein Foto?',
    },
    hours: {
      holiday_hours: 'Änder unsere Öffnungszeiten für den 24. Dezember',
    },
    order_settings: {
      minimum_order: 'Erhöh den Mindestbestellwert auf {{amount}}',
    },
    marketing: {
      promo_code: 'Erstell einen Gutscheincode über 10 % für dieses Wochenende',
    },
    my_info: {
      phone_number: 'Aktualisier unsere Telefonnummer',
    },
  },
};
